import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RegisterUserInterface } from '../interfaces/register-user.interface';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { UserUpdateInterface } from '../interfaces/update-user.interface';
import { ListUserInterface, User } from '../interfaces/list-user.interface';
import { ResponseUsersAll } from '../interfaces/response-allUser.interface';
import { CoreService } from 'src/app/shared/services/core-service.service';
import { SpinnerService } from './spinner.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private _listUserActive  = signal<ListUserInterface | any>('');
  public listUserActive$   = computed(() => this._listUserActive());
  private isFetchingUsers = false;

  private baseUrl: string   = environment.baseUrlAuth;
  private http              = inject(HttpClient);
  private _coreService      = inject( CoreService );
  private spinnerService    = inject(SpinnerService);

  initialize() {
    const authToken = localStorage.getItem('token');
    if (authToken) {
      this.fetchListUserActive();
    } else {
      console.error('No hay token de autenticación');
    }
  }


  registerUser(body: RegisterUserInterface): Observable<RegisterUserInterface[]> {
    const authToken = localStorage.getItem('token');

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });

    // console.log('Calling API with body', body, 'and headers', headers);

    return this.http.post<RegisterUserInterface[]>(`${this.baseUrl}/api/auth/register`, body, { headers })
      .pipe(
        // tap(response => console.log(response)),
        map((response: any) => response.data),
        catchError(err => {
          console.error('message',err.error.message);
          return throwError(() => err.error.message)
        })
      );
  }

  updateUser(id: string, body: UserUpdateInterface): Observable<any> {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.post<any>(`${this.baseUrl}/api/auth/updateUser?id=${id}`, body, { headers })
      .pipe(
        map((response: any) => response.data),
        catchError(err => {
          // console.log(err);
          return throwError(() => err.error.message)
        })
      );
  }


  gestListUsers(): Observable<ListUserInterface[]> {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.get<ListUserInterface[]>(`${this.baseUrl}/api/auth/all-users`, { headers })
      .pipe(
        // tap(response => console.log(response)),
        map((response: ListUserInterface[] | any) => response.users),
        // tap(response => console.log('Map:',response)),
        catchError(err => {
          // console.log(err);
          return throwError(() => err.error.message)
        })
      );
  }


  gestListUserActive(): Observable<ResponseUsersAll> {
    const apiUrl = `${this.baseUrl}/api/auth/all-users-general`;
    // const apiUrl = `${this.baseUrl}/api/auth/all-users`;
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'accept':         '*/*',
      'Content-Type':   'application/json',
      'Authorization':  `Bearer ${authToken}`
    });

    return this.http.get<ResponseUsersAll>(apiUrl, { headers }).pipe(
      map(user => ({
        ...user,
        users: user.users.filter(user => user.isActive === true)
      })),
      // map((response: ResponseUsersAll) => response),
      catchError(err => {
        // console.log(err);
        this._coreService.openErrorSnackbar(`Error al obtener la lista de usuario activos: ${err.error.message}`, 'Ok');
        return throwError(() => err.error.message)
      })
    );
  }

  private fetchListUserActive(force = false): void {
    if (this.isFetchingUsers) {
      return;
    }

    if (!force && this.hasUsersCached()) {
      return;
    }

    const apiUrl = `${this.baseUrl}/api/auth/all-users-general`;
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'accept':         '*/*',
      'Content-Type':   'application/json',
      'Authorization': `Bearer ${authToken}`
    });

    this.isFetchingUsers = true;
    this.spinnerService.show();
    this.http.get<ResponseUsersAll>(apiUrl, { headers })
    .pipe(
      map(user => ({
        // ordenar de forma alfabética la lista de usuarios activos por nombre de usuario
        ...user,
        users: user.users.filter(user => user.isActive === true)
        .sort((a: any, b: any) => {
          if (a.fristName < b.fristName) {
            return -1;
          }
          if (a.fristName > b.fristName) {
            return 1;
          }
          return 0;
        })
      })),
      catchError(err => {
        this._coreService.openErrorSnackbar(`Error al obtener la lista de usuario activos: ${err.error.message}`, 'Ok');
        return throwError(() => err);
      })
    ).subscribe({
      next: (response: ResponseUsersAll) => {
        this._listUserActive.set(response);
        this.isFetchingUsers = false;
        this.spinnerService.hide();
      },
      error: (err: any) => {
        this.isFetchingUsers = false;
        this._coreService.openErrorSnackbar(`Error al obtener la lista de usuario activos: ${err.error.message}`, 'Ok');
        console.error('Error al obtener la lista de usuario activos:', err);
      },
      complete: () => {
        this.isFetchingUsers = false;
        this.spinnerService.hide();
      }
    }
    );
  }

  // Método público para forzar una actualización de los datos
  public updateRequestUserActive(): void {
    this.fetchListUserActive(true);
  }

  private hasUsersCached(): boolean {
    const usersResponse = this._listUserActive();
    return Array.isArray(usersResponse?.users);
  }





}
